import { gql } from '@apollo/client';

export const MUTATION_UPDATE_TRANSLATION = gql`
  mutation UpdateTranslation($input: UpdateTranslationInput!) {
    updateTranslation(input: $input) {
      key
      language
      message
      success
    }
  }
`;
